import { Injectable } from '@angular/core';
import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, switchMap } from 'rxjs/operators';
import { interval, of } from 'rxjs';
import { getUnitGroupsSuccess, getUnitGroupsFailure } from '../actions/unit-groups-api.actions';
import { UnitGroupsService } from '../../../units/services/unit-groups.service';
import { getUnitGroups } from '../actions/unit-groups.actions';
import * as UnitSharedActions from '../actions/units-shared.actions';
import { cacheLifeTime } from '../../../shared/config';

@Injectable()
export class UnitGroupsEffects {

  getUnitGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getUnitGroups.type, UnitSharedActions.getData.type),
      switchMap(action =>
        this.unitGroupsService.getUnitGroups()
          .pipe(
            exhaustMap(unitGroups => of(getUnitGroupsSuccess({unitGroups: unitGroups}))),
            catchError(error => of(getUnitGroupsFailure({error})))
          )
      )
    )
  );

  @Effect()
  clear = interval(cacheLifeTime).pipe(
    switchMap((action) => of(UnitSharedActions.clearData()))
  );

  constructor(
    private actions$: Actions,
    private unitGroupsService: UnitGroupsService
  ) { }
}
